import axios, {
  AxiosError,
  isAxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

import { handleAxiosError, logUnknownError } from './errorHandler';

const clientAxios = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_APP_BASE_URL}/api`,
  headers: {},
  timeout: 8000,
});

const onRequest = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  return config;
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = (error: AxiosError | Error): Promise<AxiosError> => {
  if (isAxiosError(error) && error.response) {
    handleAxiosError(error);
  } else {
    logUnknownError(error);
  }

  return Promise.reject(error);
};

clientAxios.interceptors.request.use(onRequest);
clientAxios.interceptors.response.use(onResponse, onResponseError);

export default clientAxios;
